import React from 'react';
import { Star, Quote, Sparkles } from 'lucide-react';

export default function TestimonialsSection() {
  const reviews = [
    {
      id: 1,
      name: 'Raquel Rocha',
      role: 'Artesã & Ateliê Amigurumi',
      initials: 'RR',
      stars: 5,
      comment: 'A landing page para o meu ateliê aumentou minhas encomendas de amigurumi em mais de 300%. O modelo é lindo, super delicado e meus clientes adoram pedir direto pelo WhatsApp!'
    },
    {
      id: 2,
      name: 'Raquel Helena',
      role: 'Artesã & Ateliê de Feltro',
      initials: 'CS',
      stars: 5,
      comment: 'A estética e o painel de controle da página permitiram muita flexibilidade no meu trabalho. Posso sempre mantê-la atualizada com meus produtos sem depender de chamados de manutenção.'
    },
    {
      id: 3,
      name: 'Dra. Patricia Lima',
      role: 'Cirurgiã Dentista & Clínica Prime',
      initials: 'PL',
      stars: 5,
      comment: 'Estética impecável e navegação ultra rápida. A taxa de agendamento de consultas pelo site superou nossas expectativas. Assinatura que se paga no primeiro dia!'
    },
  ];

  return (
    <section id="reviews-section" className="section-padding" style={{ backgroundColor: '#ffffff' }}>
      <div className="container">
        <div className="text-center" style={{ maxWidth: '700px', margin: '0 auto 1.5rem' }}>
          <div className="badge badge-brand" style={{ marginBottom: '0.75rem' }}>
            <Sparkles size={14} />
            Depoimentos Reais
          </div>
          <h2 style={{ fontSize: '2.5rem', color: 'var(--text-title)' }}>
            O que nossos clientes dizem
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '1.05rem', marginTop: '0.5rem' }}>
            Confira a experiência de profissionais e empresas que transformaram seus resultados com nossos modelos.
          </p>
        </div>

        <div className="reviews-grid">
          {reviews.map((rev) => (
            <div key={rev.id} className="review-card">
              <div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                  <div className="review-stars">
                    {[...Array(rev.stars)].map((_, i) => (
                      <Star key={i} size={18} fill="#f59e0b" color="#f59e0b" />
                    ))}
                  </div>
                  <Quote size={24} color="#cbd5e1" />
                </div>
                <p className="review-comment">"{rev.comment}"</p>
              </div>

              <div className="review-author">
                <div className="author-avatar">{rev.initials}</div>
                <div className="author-info">
                  <h4>{rev.name}</h4>
                  <p>{rev.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
